import React from 'react';
import PropTypes from 'prop-types';
import { Button, Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';
import { useCheckAuthState } from '@/hooks';
import { VoidIcon } from '@/resources/icons';

import useStyles from '../../styles';

const handleOnClick = async ({
    onWarningActive,
    onLoginBlocker,
    registeredUser
}) => {
    if (registeredUser) {
        onWarningActive();
    } else {
        onLoginBlocker(onWarningActive);
    }
};

const EstimateVoid = ({ onLoginBlocker, onWarningActive }) => {
    const classes = useStyles();
    const { loadingUser, registeredUser } = useCheckAuthState();
    const documentState = useSelector(
        (state) => state?.makeInvoice?.documentState
    );

    const isDraft = documentState === 'draft';
    const isVoid = documentState === 'void';

    if (!isDraft && !isVoid) {
        return (
            <div className={classes.section}>
                {!loadingUser ? (
                    <Button
                        fullWidth
                        className={`${classes.button} ${classes.negativeButton}`}
                        variant="outlined"
                        endIcon={<VoidIcon className={classes.buttonVoidSvg} />}
                        size="large"
                        onClick={() =>
                            handleOnClick({
                                onWarningActive,
                                onLoginBlocker,
                                registeredUser
                            })
                        }
                    >
                        Void
                    </Button>
                ) : (
                    <Skeleton variant="rectangular" className={classes.sizer} />
                )}
            </div>
        );
    }

    return null;
};

EstimateVoid.propTypes = {
    onLoginBlocker: PropTypes.func.isRequired,
    onWarningActive: PropTypes.func.isRequired
};

export default EstimateVoid;
